import {createAsyncThunk} from '@reduxjs/toolkit';
import {DeviceCategoryClient} from '../../../api/api';
import {AsyncOperationHandler} from '../../../utilities/platform-helpers/api-helper';
import {deviceCategoryClient} from '../../api-clients';

export const getDeviceCategories = createAsyncThunk('deviceCategories/getDeviceCategories', () => {
  return AsyncOperationHandler((client) => (client as DeviceCategoryClient).get(), deviceCategoryClient);
});
